module.exports = __webpack_public_path__ + "img/common-file-download.be13202c.svg";